import { Ds } from "@accurx/design";

type FakeDisabledSelectProps = {
    label: string;
    description?: string;
    value: string;
};

export function FakeDisabledSelect({
    label,
    description,
    value,
}: FakeDisabledSelectProps) {
    return (
        <Ds.Box mb="3">
            <Ds.Form.Label>{label}</Ds.Form.Label>
            {description && (
                <Ds.Form.Description>{description}</Ds.Form.Description>
            )}
            <Ds.Box
                backgroundColor="cloud"
                p="1.5"
                style={{ borderRadius: "var(--ds-border-radius)" }}
            >
                <Ds.Badge color="greyscale">{value}</Ds.Badge>
            </Ds.Box>
        </Ds.Box>
    );
}
